import React from 'react'
import './ConfirmationPopup.css'
function SuccessPopup(props) {
  
  return (
    <div className='ConfirmationPopup'>
            <div className='Confirm-Body'>
            <div className='Cross-div'>
                        <img src='/assets/CrossPopup.png' className='Cross' onClick={()=>props.onClose()}/>
                    </div>
                <div className='Confirm-inner-body'>
                   
            <p className='heading'>Swap Successful!</p>
            
           
    
    <p className='subtext' style={{textAlign:'center'}}>Your transaction has been successfully made.</p>

  
    <a className='Confirm-btn' href='https://www.eggheadsclub.io/store' onClick={()=>props.onClose()}>
    Go back to Marketplace
        </a>
            </div>
            </div>
        
    </div>
  )
}

export default SuccessPopup